import MainContactObj from './main-contact.object'
import BillingContactObj from './billing-contact.object'
import AddressObj from './address.object'

export default class ClientObj {
    typeAccount
    stateRegistration
    registryDate
    name
    municipalRegistration
    marketClient
    fantasyName
    document
    mainContact
    billingContact
    address
    activityArea

    constructor () {
      this.mainContact = new MainContactObj()
      this.billingContact = new BillingContactObj()
      this.address = new AddressObj()
    }
}
